import OrderConfirmationContent from 'components/order-confirmation/OrderConfirmationContent';
import { orderConfirmationPagePreviews } from 'components/order-confirmation/orderConfirmationPreviewData';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';

const ComponentPreview = () => {
  return (
    <OrderConfirmationContent {...orderConfirmationPagePreviews[0].props} />
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Order Confirmation',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
